export const withNull = <T extends {}>(lst: T[]) => [...(lst || []), { name: '未入力', id: 'empty' }];
